import PropTypes from 'prop-types';

const Carrier = PropTypes.shape({
  key: PropTypes.string,
  name: PropTypes.string,
});

export default Carrier;
